import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate, useSearchParams } from 'react-router-dom';

function GoogleCallback() {
  const cookie = useCookies();
  const setCookie = cookie[1];
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  React.useEffect(() => {
    const token = searchParams.get('token');
    const userID = searchParams.get('userid');
    if (token && userID) {
      setCookie('userToken', token, { path: '/' });
      setCookie('userID', userID, { path: '/' });
    }
    navigate('/dashboard');
  }, [navigate, searchParams, setCookie]);

  return (
    <Grid height='100vh' container justifyContent='center' alignItems='center'>
      <Typography color={(theme) => theme.palette.grey[800]}>
        Please Wait ...
      </Typography>
    </Grid>
  );
}

export default GoogleCallback;
